
import axiosVirdioT from '../utils/axios';
var axiosVirdio = new axiosVirdioT(); 


const openOnDemandClass = function(classId) {
	return new Promise(function (resolve, reject) {
		let userData = JSON.parse(localStorage.getItem('userData'));
		let token = userData.token;
		axiosVirdio.auth(token);
		var postData = { classId: classId };
		axiosVirdio.post(process.env.REACT_APP_API_URL+"/api/v1/session/individualDemandDetails", postData).then(res => {
			var mainResponse = res.data.responseData;
			var storage = JSON.parse(localStorage.getItem('userData'));
			storage['userType'] = 2;
 			storage.sessionData = JSON.parse(JSON.stringify(mainResponse));
			localStorage.setItem("userData", JSON.stringify(storage));
			
			resolve('success');
		}).catch( err => { if ( err && err.response ) { reject(err.response.data.errorData); } });
	})
}


export { openOnDemandClass } 